module.exports = __webpack_public_path__ + "static/media/logo.607afcc6.ico";